import { Model, modelRegistry } from './Model';
import { AppStorageKey } from '../types';
import { Terminal, User } from '../models';
import { diContainer } from '../DIContainer';
import Store from '../wrappers/Store';
import HashGen from '../utilities/HashGen';
import Shift from './Shift';
import moment from 'moment-timezone';
export class SyncData extends Model {
    static entity = 'sync_data';
    static primaryKey = 'hash';
    static get appStorage() {
        return diContainer.resolve('appStorage');
    }
    hash = '';
    venue = '';
    user_id = null;
    terminal_id = null;
    shift_hash = null;
    data = [];
    action = null;
    type = null;
    created_at = null;
    static fields() {
        return {
            hash: this.attr(HashGen.regular()),
            venue: this.attr(''),
            user_id: this.attr(null),
            terminal_id: this.attr(null),
            shift_hash: this.attr(null),
            data: this.attr([]),
            type: this.attr(''),
            action: this.attr(''),
            created_at: this.attr(''),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    static async createNew(type, data, action) {
        const curTerminal = await Terminal.current();
        const curShift = Shift.current();
        const curUser = User.current();
        return new SyncData({
            hash: HashGen.regular(),
            venue: Store.get('tenant')?.venue?.hash || '',
            user_id: curUser?.id || null,
            terminal_id: curTerminal?.id || null,
            shift_hash: curShift?.hash || null,
            data,
            type,
            action,
            created_at: moment().utc().format(SyncData.DATE_FORMAT)
        });
    }
    async saveForSync() {
        this.$save();
        const syncDataFromNativeStore = await SyncData.appStorage.native().getItem(AppStorageKey.syncData) || [];
        const existsInNativeSyncData = syncDataFromNativeStore.some(sd => sd.hash === this.hash);
        if (existsInNativeSyncData)
            return;
        syncDataFromNativeStore.push(this.$toJson());
        await SyncData.appStorage.native().setItem(AppStorageKey.syncData, syncDataFromNativeStore);
    }
    static async deleteModels(models) {
        if (!models.length)
            return;
        const syncData = await SyncData.getDataForSync();
        for (const model of models) {
            for (const sd of syncData) {
                if (sd.data.some(modelForSync => modelForSync.hash === model.hash)) {
                    sd.data = sd.data.filter(modelForSync => modelForSync.hash !== model.hash);
                }
            }
        }
        const remainingSyncData = syncData.filter(sd => sd.data.length > 0);
        SyncData.create({ data: remainingSyncData });
        await SyncData.appStorage.native().setItem(AppStorageKey.syncData, remainingSyncData);
    }
    static async deleteModelsBackup(models) {
        if (!models.length)
            return;
        const syncData = await SyncData.getDataForSync(true);
        for (const model of models) {
            for (const sd of syncData) {
                if (sd.data.some(modelForSync => modelForSync.hash === model.hash)) {
                    sd.data = sd.data.filter(modelForSync => modelForSync.hash !== model.hash);
                }
            }
        }
        const remainingSyncData = syncData.filter(sd => sd.data.length > 0);
        await SyncData.appStorage.native().setItem(AppStorageKey.syncDataBackup, remainingSyncData);
    }
    async saveForSyncBackup() {
        const syncDataFromBackupStore = await SyncData.getDataForSync(true);
        syncDataFromBackupStore.push(this.$toJson());
        await SyncData.appStorage.native().setItem(AppStorageKey.syncDataBackup, syncDataFromBackupStore);
    }
    static async deleteItems(data) {
        const syncData = await SyncData.getDataForSync();
        const remainingSyncData = syncData.filter(sd => !data.some(i => i.hash === sd.hash));
        SyncData.create({ data: remainingSyncData });
        await SyncData.appStorage.native().setItem(AppStorageKey.syncData, remainingSyncData);
    }
    static async deleteItemsBackup(data) {
        const syncData = await SyncData.getDataForSync(true);
        const remainingSyncData = syncData.filter(sd => !data.some(i => i.hash === sd.hash));
        await SyncData.appStorage.native().setItem(AppStorageKey.syncDataBackup, remainingSyncData);
    }
    static async deleteAll() {
        SyncData.create({ data: [] });
        await SyncData.appStorage.native().setItem(AppStorageKey.syncData, []);
    }
    static async deleteAllBackup() {
        await SyncData.appStorage.native().setItem(AppStorageKey.syncDataBackup, []);
    }
    static async getDataForSync(fromBackupStore = false) {
        if (fromBackupStore) {
            const syncData = await SyncData.appStorage.native().getItem(AppStorageKey.syncDataBackup) || [];
            return syncData;
        }
        const syncDataFromPrimaryStore = SyncData.all().map(sd => sd.$toJson());
        const syncDataFromNativeStore = await SyncData.appStorage.native().getItem(AppStorageKey.syncData) || [];
        for (const data of syncDataFromNativeStore) {
            const existsInPrimaryStore = syncDataFromPrimaryStore.some(sd => sd.hash === data.hash);
            if (!existsInPrimaryStore)
                syncDataFromPrimaryStore.push(data);
        }
        return syncDataFromPrimaryStore;
    }
}
export default SyncData;
modelRegistry.register('SyncData', SyncData);
//# sourceMappingURL=SyncData.js.map